export default __webpack_public_path__ + "e948c83ed6d62a031fa6b925e68f7a67.png";